import React from 'react';
import Table from 'react-bootstrap/Table';

export default function GenInstructionCBSE() {
  return (
    <div className="geninst-bg">
      <div className="geninst-card shadow geninst-left">
        <h2 className="geninst-title mb-4 text-start text-center">Application Instructions</h2>
        <Table bordered hover responsive className="geninst-table mb-4" style={{width:"600px"}}>
            <Table bordered hover className="geninst-table mb-4">
            <tr><td className="geninst-step">1</td><td colSpan={3}>This is the online application. Please follow the steps below to complete the process.</td></tr>
            <tr><td className="geninst-step">2</td><td colSpan={3}>Read the application carefully and fill it up without any mistakes.</td></tr>
            <tr>
              <td className="geninst-step">3</td>
              <td style={{lineHeight:2, textAlign:'justify'}}>
               
                After filling up the online application form, take a printout, attach photocopies of the following documents in the order shown in your printed application form and send to the address provided.
           {/*}     
              <Table size="sm" className="geninst-inner-table mt-2 mb-2" style={{maxWidth:"50%"}}>
                <tbody>
                  <tr><td colSpan={2} className="fw-bold">FOR B.T.Assistant</td></tr>
                  <tr><td style={{maxWidth:"25%"}}>1. X Mark Sheet</td><td>4. UG - Degree Certificate</td></tr>
                  <tr><td>2. XII Mark Sheet</td><td>5. PG - Degree Certificate</td></tr>
                  <tr><td>3. UG Consolidated Mark Sheet</td><td>6. TET Qualified Certificate</td></tr>
                </tbody>
              </Table>
              <Table size="sm" className="geninst-inner-table mb-2" style={{maxWidth:"50%"}}>
                <tbody>
                  <tr><td colSpan={2} className="fw-bold">FOR P.G.Assistant</td></tr>
                  <tr><td style={{maxWidth:"25%"}}>1. X Mark Sheet</td><td>4. UG - Degree Certificate</td></tr>
                  <tr><td>2. XII Mark Sheet</td><td>5. PG - Degree Certificate</td></tr>
                  <tr><td>3. UG Consolidated Mark Sheet</td><td>6. PG Consolidated Mark Sheet</td></tr>
                </tbody>
              </Table> */}
            </td></tr>
           {/* <tr><td className="geninst-step">4</td><td colSpan={3}>Challan/pay slips/UTR NEFT receipts, as per the number of applications for which you have applied.</td></tr> */}
            <tr style={{lineHeight:2, textAlign:'justify'}}><td className="geninst-step">4</td><td colSpan={3}>Application(s) along with photocopies should be sent by courier or handed over in person to <span className="fw-bold">The Co-ordinator, St. Mary's Higher Secondary School, Madurai - 625001, Tamilnadu, India</span> and to <span className="fw-bold">The Director, Beschi Campus, Dindigul - 624001, Tamilnadu, India applied.</span></td></tr>
         {/*}   <tr style={{lineHeight:2, textAlign:'justify'}}><td className="geninst-step">6</td><td colSpan={3}>
              Kindly use the following account number to pay the application fee of <b>Rs 200/-</b> for each application.
              <Table size="sm" className="geninst-inner-table mt-2 mb-2" style={{maxWidth:"50%"}}>
                <tbody>
                  <tr><td>Account Name</td><td>:</td><td>SCHOOL EDCATION COMMISSION</td></tr>
                  <tr><td>Account No</td><td>:</td><td>527266917</td></tr>
                  <tr><td>Bank</td><td>:</td><td>INDIAN BANK</td></tr>
                  <tr><td>Branch</td><td>:</td><td>East Veli Street, Madurai</td></tr>
                  <tr><td>IFSC Code</td><td>:</td><td>IDIB000E002</td></tr>
                  <tr><td colSpan={3}><span className="text-primary">QR Code Payment Link: <a href="#">Payment : QR Code Link</a></span></td></tr>
                </tbody>
              </Table>
            </td></tr>
            <tr><td className="geninst-step">7</td><td colSpan={3}>No Demand Draft will be accepted; Application fee is not refundable.</td></tr>*/}
            <tr><td className="geninst-step">5</td><td colSpan={3}>Applications not duly filled in and not attached with the proper documents will be summarily rejected.</td></tr>
            <tr><td className="geninst-step">6</td><td colSpan={3}>No corrections will be carried out once the application form is submitted. Hence, please check your application details before submitting the application.</td></tr>
            <tr><td className="geninst-step">7</td><td colSpan={3}><span className="text-danger fw-bold">Help desk: Email: coordinator@mduschooled.in</span></td></tr>
        </Table>
        </Table>
        <div className="geninst-address mt-4 text-start text-center">
          <h5 className="fw-bold mb-1">The Co-ordinator,</h5>
          <div>St. Mary's Higher Secondary School,</div>
          <div>Madurai - 625001, Tamilnadu, India.</div>
        </div>
        <div className="geninst-address mt-4 text-start text-center">
          <h5 className="fw-bold mb-1">The Director,</h5>
          <div>Loyola Tech School,</div>
          <div>Beschi Campus, Dindigul - 624001, Tamilnadu, India.</div>
        </div>
      </div>
      <style>{`
        .geninst-card {
          max-width: 900px;
          margin: 2rem auto;
          background: #fff;
          border-radius: 18px;
          box-shadow: 0 6px 32px 0 rgba(44,62,80,0.13);
          padding: 2.5rem 2rem 2rem 2rem;
          text-align: left;
        }
        .geninst-title {
          color: #1a2740;
          letter-spacing: 1px;
          font-weight: 700;
        }
        .geninst-address {
          text-align: left;
        }
        .geninst-table {
          background: #f8fafc;
          border-radius: 12px;
          overflow: hidden;
          white-space: normal !important;
        }
        .geninst-step {
          font-weight: 700;
          white-space: nowrap;
          color: #fff;
          background: #1565c0;
          border-radius: 50%;
          width: 3em;
          height: 3em;
          min-width: 3em;
          min-height: 3em;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.1em;
          vertical-align: top;
          flex-shrink: 0;
        }
        .geninst-inner-table td {
          background: #f3f6fa;
          border-radius: 6px;
        }
        .geninst-address {
          background: #e3f2fd;
          border-radius: 10px;
          padding: 1.2rem 1rem;
          text-align: center;
          color: #1a2740;
          box-shadow: 0 2px 8px 0 rgba(21,101,192,0.08);
        }
        @media (max-width: 767.98px) {
          .geninst-card { padding: 1.2rem 0.5rem; }
          .geninst-title { font-size: 1.3rem; }
        }
      `}</style>
    </div>
  );
}
